import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "@material-ui/styles";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import { LayoutProvider } from "./context/LayoutContext";
import { UserProvider } from "./context/UserContext";
import { ManagementProvider } from "./context/ManagementContext";
import {
  ThemeProvider as ThemeChangeProvider,
  ThemeStateContext
} from "./context/ThemeContext";
import { CssBaseline } from "@material-ui/core";
import {GoogleMapsContext} from "./context/GoogleMapsContext";
import {setLoginPath} from "./pages/newLogin";

window.addEventListener("hashchange", () => setLoginPath())
setLoginPath();

ReactDOM.render(
    <GoogleMapsContext apiKey="AIzaSyAqroR5twha43Pwj7L2INP4iN9ngGW6xPs">
        <LayoutProvider>
            <UserProvider>
                <ThemeChangeProvider>
                    <ThemeStateContext.Consumer>
                        {theme => (
                            <ThemeProvider theme={theme}>
                                <ManagementProvider>
                                    <CssBaseline />
                                    <App />
                                </ManagementProvider>
                            </ThemeProvider>
                        )}
                    </ThemeStateContext.Consumer>
                </ThemeChangeProvider>
            </UserProvider>
        </LayoutProvider>
    </GoogleMapsContext>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
